/**
 * ¿El usuario autenticado es super admin de la plataforma?
 *
 * Pregunta a `is_super_admin()` —la sobrecarga SIN argumento—, que lee
 * `platform_admins`: la única fuente de verdad, la misma que aplican las policies
 * RLS. Antes esta pregunta se
 * respondía con un array de emails que viajaba EN EL BUNDLE: además de publicar
 * el correo del super admin a cualquier visitante, era una de tres copias que se
 * desincronizaban entre sí (las otras dos vivían en el cuerpo de
 * `is_super_admin()` y en la edge function de impersonación).
 *
 * Va por TanStack Query (ADR-0012): el dato es el mismo para toda la sesión y no
 * hay razón para pedirlo una vez por componente.
 *
 * ⚠️ Esto es para DECIDIR QUÉ MOSTRAR, no para proteger nada. Lo que protege los
 * datos son las policies RLS, que leen la misma tabla del lado del servidor. Un
 * `false` acá esconde un botón; no es lo que impide leer una fila.
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export function useIsSuperAdmin(): boolean {
  const { data } = useQuery({
    queryKey: ['is-super-admin'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('is_super_admin');
      if (error) throw error;
      return data === true;
    },
    // Quién es super admin no cambia dentro de una sesión: pedirlo de nuevo al
    // volver a la pestaña es ruido.
    staleTime: Infinity,
    retry: false,
  });
  // `undefined` (cargando o error) se trata como NO: ante la duda, no se muestra.
  return data === true;
}
